import { useQuery } from "@tanstack/react-query";
import { invoice } from "./query";
import { PostModel } from "common/models/BaseModel";
import { IInvoiceGridFilter } from "./types";

export function GetInvoices(model: PostModel<IInvoiceGridFilter> | undefined) {
  return useQuery(invoice.list(model));
}

export function GetInvoice(Id: string | number) {
  return useQuery({
    ...invoice.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetPurchaseOrderItemsForInvoicing(purchaseOrderId: string | number | undefined | null) {
  return useQuery({
    ...invoice.getPurchaseOrderItemsForInvoicing(purchaseOrderId || ""),
    enabled: Boolean(purchaseOrderId),
  });
}

export function GetInvoiceView(id: string | number, isOpen: boolean) {
  return useQuery({
    ...invoice.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}

export function GetPendingInvoiceSummary() {
  return useQuery(invoice.getPendingSummary());
}

export function GetInvoiceItemsForAccession(id: string | number, isOpen: boolean) {
  return useQuery({
    ...invoice.getAccessionItems(id),
    enabled: Boolean(id) && isOpen,
  });
}

